import { defineStyle } from '@chakra-ui/react';

const style = defineStyle({
  root: {
    p: '20px',
    gap: '20px',
    '.guideSkeleton': {
      height: '1px',
    },
    '.guideSkeletonText1': {
      noOfLines: 1,
      w: '70px',
    },
    '.guideSkeletonText2': {
      noOfLines: 2,
    },
    '.guideSkeletonText3': {
      noOfLines: 3,
    },
  },
});

export default style;
